var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"course__lesson"},[_c('span',[_c('i',{staticClass:"fal fa-clock"}),_vm._v(" "+_vm._s(_vm.item.duration)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }